import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import api from "./Axios/api";
import { FileText, MoveLeft, Pencil ,Trash2} from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import Loader from "./common/Loader";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
const CreatedPOList = () => {
  const [active, setActive] = useState("ALL");
  const userRole = useSelector((state) => state.user.staff_role);
  const auditor = useSelector((state) => state.user.staff_name);
  const currentStaffFacLoc = useSelector((state) => state.user.staff_FacLoc);

  const navigation = useNavigate();
  const { voc_id, fac_id } = useParams();
  const [isloading, setIsLoading] = useState(false);
  const [month, setMonth] = useState("");
  const [data, setData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
 
  const getData = async () => {
  try {
    setIsLoading(true); 
    let res;
    if (voc_id && fac_id) {
      res = await api.get(
        `/po-detail/get?fac_id=${fac_id}&voucher_id=${voc_id}&status=1`
      );
      setData(res.data);
    } else {
      res = await api.get(`/po-detail/get?month=${month}&status=1`);
      const sortedData = res.data.sort(
        (a, b) => new Date(b.po_date) - new Date(a.po_date)
      );
      setData(sortedData);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setIsLoading(false); 
  }
};

  const getDetailsForExcel = async () => {
    try {
      const selectedIds = Object.keys(rowSelection)
        .filter((index) => rowSelection[index])
        .map((index) => data[parseInt(index)]._id);
      // console.log(selectedIds);
      const res = await Promise.all(
        selectedIds.map(
          async (id) =>
            (
              await api.get(`/po-detail/get-excel-detail/${id}`)
            ).data
        )
      );
      const allData = res.flat(); // Use flat() to merge nested arrays
      setExcelData(allData);
      // console.log("excel", allData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDetailsForExcel();
  }, [rowSelection]);

   const handleClosePO = async (id) =>
   {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: `Do you want to Delete PO ?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, close it!",
        });

     if (result.isConfirmed) {
       try {
           await api.patch(`/po-detail/close-status/${id}`);
                Swal.fire({
                  icon: "success",
                  title: "PO Deleted",
                  text: `PO has been successfully closed.`,
                  timer: 1000,
                  showConfirmButton: false,
                });
                getData();
       }
       catch(error)
       {
         Swal.fire({
                   icon: "error",
                   title: "Error when deleting PO",
                   text: error.response?.data?.message || "Something went wrong.",
                 });
       }
    }
}
  
  const handlePrint = (cell) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = `https://purchase24.polybonderps.site/purchase-print/po-print.php`; 
    form.target = "_blank";

    const poIdInput = document.createElement("input");
    poIdInput.type = "hidden";
    poIdInput.name = "poId";
    poIdInput.value = cell.getValue();
    form.appendChild(poIdInput);

    const dataInput = document.createElement("input");
    dataInput.type = "hidden";
    dataInput.name = "token";
    dataInput.value = JSON.stringify(Cookies.get("access_token"));
    form.appendChild(dataInput);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  useEffect(() => {
    getData();
  }, [month]);
  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const monthNum = String(now.getMonth() + 1).padStart(2, "0");
    const currentMonth = `${year}-${monthNum}`;
    setMonth(currentMonth);

  }, []);
  const branchMapping = {
    "666c0f5ebeca5ab2c65b2c85": "INSULATION",
    "666c0f5ebeca5ab2c65b2c86": "PROJECTS",
    "666c0f5ebeca5ab2c65b2c87": "ROCKFIBRE",
  };

  const buttons =
    userRole === "666c0f8ebeca5ab2c65b35a9" ||  auditor === "PolyBond Audit"
      ? ["ALL", "INSULATION", "PROJECTS", "ROCKFIBRE"]
      : [ branchMapping[currentStaffFacLoc]].filter(Boolean);

  const filteredData = useMemo(() => {
    if (active === "ALL") return data;

    return data.filter((row) => {
      const branchName = branchMapping[row.po_branch];
      return branchName === active;
    });
  }, [active, data]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "po_date",
        header: "Date",
        size: 150,
        Cell: ({ cell }) => new Intl.DateTimeFormat("en-GB").format(new Date (cell.getValue())),
      },
      {
        accessorKey: "po_number",
        header: "PO NO.",
        size: 150,
      },
      {
        accessorKey: "party_name",
        header: "PARTY",
        size: 150,
      },
      {
        accessorKey: "created_by_name",
        header: "Created by",
        size: 150,
      },
      {
        accessorKey: "po_branch",
        header: "PO Branch",
        size: 150,
        Cell: ({ cell }) => {
          const branchId = cell.getValue();
          const branchName = branchMapping[branchId] || "UNKNOWN";

          return <div className="max-h-10 overflow-y-auto">{branchName}</div>;
        },
      },
      {
        accessorKey: "_id",
        header: "Action",
        size: 200,
        Cell: ({ cell }) => (
          <div className="flex items-center gap-3">
            {/* <Link to={`https://polybonderps.site/purchase-print/po-print.php?poId=${cell.getValue()}`} target='_blank' state={{ data: 'dummy' }}> */}
            <div onClick={() => handlePrint(cell)}>
              <button>
                <FileText size={20} />
              </button>
            </div>
            {auditor !== "PolyBond Audit" 
            &&(
              <>
            <div
              onClick={() =>
                navigation(`/create-po-form`, {
                  state: { poId: cell.getValue() },
                })
              }
            >
              <button>
                <Pencil size={18} />
              </button>
            </div>

            <div
              onClick={() => handleClosePO(cell.getValue())}
            >
              <button>
                <Trash2 size={18} />
              </button>
            </div>
            </>
            )}
          </div>
        ),
      },
    ],
    []
  );

  const exportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const formatedData = [];

    excelData.forEach((row) => {
      row.indent_item_info.forEach((item) => {
        const gstRate = parseFloat(item.item_gst) || 0;
        const baseAmount = item.purchase_info.total_without_gst || 0;
        const isCG =
          item.purchase_info.vendor_gstno &&
          item.purchase_info.vendor_gstno.startsWith("22");

        const halfGst = gstRate / 2;
        const halfGstAmount = baseAmount * (halfGst / 100);
        const fullGstAmount = baseAmount * (gstRate / 100);
        
         const vendorGst = item.purchase_info.vendor_gstno || "";
         const vendorCode = vendorGst.substring(0, 2);

        const gstStateCodes = [
                                { code: "01", state: "Jammu & Kashmir" },
                                { code: "02", state: "Himachal Pradesh" },
                                { code: "03", state: "Punjab" },
                                { code: "04", state: "Chandigarh" },
                                { code: "05", state: "Uttarakhand" },
                                { code: "06", state: "Haryana" },
                                { code: "07", state: "Delhi" },
                                { code: "08", state: "Rajasthan" },
                                { code: "09", state: "Uttar Pradesh" },
                                { code: "10", state: "Bihar" },
                                { code: "11", state: "Sikkim" },
                                { code: "12", state: "Arunachal Pradesh" },
                                { code: "13", state: "Nagaland" },
                                { code: "14", state: "Manipur" },
                                { code: "15", state: "Mizoram" },
                                { code: "16", state: "Tripura" },
                                { code: "17", state: "Meghalaya" },
                                { code: "18", state: "Assam" },
                                { code: "19", state: "West Bengal" },
                                { code: "20", state: "Jharkhand" },
                                { code: "21", state: "Odisha" },
                                { code: "22", state: "Chhattisgarh" },
                                { code: "23", state: "Madhya Pradesh" },
                                { code: "24", state: "Gujarat" },
                                { code: "25", state: "Daman & Diu" },
                                { code: "26", state: "Dadra & Nagar Haveli" },
                                { code: "27", state: "Maharashtra" },
                                { code: "28", state: "Andhra Pradesh (Old)" },
                                { code: "29", state: "Karnataka" },
                                { code: "30", state: "Goa" },
                                { code: "31", state: "Lakshadweep" },
                                { code: "32", state: "Kerala" },
                                { code: "33", state: "Tamil Nadu" },
                                { code: "34", state: "Puducherry" },
                                { code: "35", state: "Andaman & Nicobar Islands" },
                                { code: "36", state: "Telangana" },
                                { code: "37", state: "Andhra Pradesh (New)" }
                              ];
        const stateObj = gstStateCodes.find((s) => s.code === vendorCode);
        const vendorState = stateObj ? stateObj.state : " ";

        formatedData.push([
          row.po_number || "",
          row.po_date
            ? row.po_date.split("T")[0].split("-").reverse().join("-")
            : "",

          vendorState,

          item.purchase_info.vendor_gstno || "",
          item.purchase_info.party_name || "",
          row.voucher_type_name || "",

          item.item_title,
          item.purchase_info.purchase_qty,
          item.purchase_info.rate,

          item.purchase_info.discount || "",
          baseAmount,
          isCG ? halfGst : "",
          isCG ? halfGstAmount : "",
          isCG ? halfGst : "",
          isCG ? halfGstAmount : "",
          !isCG ? gstRate : "",
          !isCG ? fullGstAmount : "",
          "",

          row.po_number || "",
          row.po_date
            ? row.po_date.split("T")[0].split("-").reverse().join("-")
            : "",

          (item.purchase_info.stock_desc || "").split(/\r?\n/)[0] || "",
          (item.purchase_info.stock_desc || "").split(/\r?\n/)[1] || "",
          (item.purchase_info.stock_desc || "").split(/\r?\n/)[2] || "",

          row.purchase_ledger_name || "",
          row.terms_of_payment || "",
          row.fright || "",

          (
            (row.delivery_terms || "").replace(/\r/g, "").split(";")[0] || ""
          ).trim(),
          (
            (row.delivery_terms || "").replace(/\r/g, "").split(";")[1] || ""
          ).trim(),
          (
            (row.delivery_terms || "").replace(/\r/g, "").split(";")[2] || ""
          ).trim(),

          row.dispatch_through || "",
          row.destination || "",
          `Terms & Conditions:
1. Order no. should be mentioned on delivery challan / invoice.
2. Rejection on account of quality, material specification etc, and delivery will be in your account; rejected material must be collected from our works immediately on receipt of rejection note.
3. All prices shall remain firm till the completion of this contract.
4. All disputes are subject to Durg jurisdiction only.`,
        ]);
      });
    });

    // Define Headers (First Row)
    const header1 = [
      "VCH",
      "VCH",
      "State Name",
      "GSTIN",
      "Customer Name",
      "Voucher",
      "Product Name",
      "Quantity",
      "Rate",
      "Disc %",
      "Amount",
      "CGST %",
      "CGST",
      "SGST %",
      "SGST",
      "IGST %",
      "IGST",
      "TCS",
      "Refrence",
      "Refrence",
      "Stock",
      "Stock",
      "Stock",
      "Purchase",
      "Terms Of",
      "Other",
      "Terms Of",
      "Terms Of",
      "Terms Of",
      "Dispatch Through",
      "Destination",
      "Narration",
    ];

    // Define Sub-Headers (Second Row)
    const header2 = [
      "No.",
      "Date",
      "",
      "",
      "",
      "Type",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "No.",
      "Date",
      "Desc1",
      "Desc2",
      "Desc3",
      "Ledger",
      "Payment",
      "",
      "Delievery1",
      "Delievery2",
      "Delievery3",
    ];

    // Create worksheet and insert headers
    const sheet = XLSX.utils.aoa_to_sheet([header1, header2, ...formatedData]);
    XLSX.utils.book_append_sheet(workbook, sheet, "Report");
    XLSX.writeFile(workbook, "PO_Export.xlsx");
  };

  const table = useMaterialReactTable({
    columns,
    data: filteredData,
    enableRowSelection: true,
    getRowId: (row) => row.userId,
    onRowSelectionChange: setRowSelection,
    state: { rowSelection },
    renderToolbarAlertBannerContent: ({ table }) => {
      return (
        <div className="flex gap-2 px-1 mt-1">
        {auditor !== "PolyBond Audit"
            &&(   <button
            className="p-1 bg-[#EEEDEB] rounded-t-lg shadow-sm"
            onClick={exportToExcel}
          >
            <span className="text-sm">Export Excel</span>
          </button>
            )}
        </div>
      );
    },
  });

  const handleBackClick = () => {
    navigation(-1);
  };
  return (
    <div className="flex-1 px-5 w-full justify-center items-center">
      <div className="px-2 py-4 rounded-md bg-[#fdfdfd] shadow my-2">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full px-3 gap-4">
          <div className="text-lg text-violet-500 font-bold">
            Create PO List
          </div>
            
          <div className="flex flex-wrap gap-3">
               <div className="mb-4 space-x-2">
              <input
                type="month"
                value={month}
                onChange={(e) => {
                  setMonth(e.target.value);
                }}
                className="border rounded px-2 py-1"
              />
            </div>
            {!(voc_id && fac_id) &&
              buttons.map((btn) => (
                <button
                  key={btn}
                  onClick={() => setActive(btn)}
                  className={`px-6 py-2 rounded text-sm font-medium ${
                    active === btn
                      ? "bg-[#7C3AED] text-white"
                      : "bg-[#EEEDEB] text-black"
                  }`}
                >
                  {btn}
                </button>
              ))}
              
            <button
              className={`px-6 py-2 rounded text-sm font-medium bg-[#7C3AED] text-white`}
              onClick={() => navigation("/create-po")}
            >
              VOUCHER 
            </button>
            <button
              className={`flex items-center gap-1 px-5 py-1 rounded text-sm font-medium bg-[#7C3AED] text-white  bg-gradient-to-r from-violet-500 via-violet-600 to-violet-700 hover:bg-gradient-to-br focus:outline-none  text-center`}
              onClick={handleBackClick}
            >
              <MoveLeft size={20} />
              Back
            </button>
          </div>
        </div>
      </div>

      <div className="w-full min-h-[500px] rounded-md shadow bg-[#fdfdfd]">
        {  isloading ? ( <Loader/>):(
        <MaterialReactTable table={table} />
        )}
      </div>
    </div>
  );
};

export default CreatedPOList;
